import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { IMyMonitoringUserModel } from '@apps-common/types/portal/users'

export const getClientAccountAssociation = async (id: number, unitId: string): Promise<IMyMonitoringUserModel> =>
  axios.get(`/clientaccount/GetAccountAssociation?clientId=${id}&unitId=${unitId}`).then((res) => res.data?.data)
type QueryFnType = typeof getClientAccountAssociation

type Props = {
  config?: QueryConfig<QueryFnType>
  userId: number
  unitId: string
}

export const useGetClientAccountAssociation = ({ config, userId, unitId }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['getClientAccountAssociation', userId, unitId],
    queryFn: () => getClientAccountAssociation(userId, unitId)
  })
